import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import { formatCpfCnpj } from '../../../../helpers/utils/utils';
import * as C from '../../../theme/colors.constants';

/**
 * Tabela de devedores do grupo (AW2-1134 Etapa 8) — porta de
 * `TableDevedorGrupo.jsx` real, populada pelo resultado de
 * `buscarDevedorGrupo` (disparado a partir do campo "Cód. Devedor
 * principal:" em `AbaDevedor.jsx`). Substitui a tabela mockada
 * (`ANTECEDENTES_DEVEDOR` estático) que existia antes desta etapa.
 *
 * Colunas e nomes de campo do DTO de resposta (`idDevedor`, `razaoSocial`,
 * `nomeFantasia`, `cnpjCpf`, `cidade`, `idEstado`) confirmados por leitura
 * direta do componente real — `idEstado` é exibido CRU, sem lookup para
 * sigla/nome do estado (mesma limitação da produção real, não corrigida
 * aqui por não ser um bug desta etapa nem pedido pelo plano).
 */
export default function TableDevedorGrupo({ content }) {
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Código</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell>Nome Fantasia</TableCell>
            <TableCell>CPF/CNPJ</TableCell>
            <TableCell>Cidade</TableCell>
            <TableCell>Estado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {content.map(devedor => (
            <TableRow key={devedor.idDevedor} hover>
              <TableCell sx={{ color: C.navy, fontWeight: 600 }}>
                {Number(devedor.idDevedor).toLocaleString('pt-BR', { minimumFractionDigits: 0 })}
              </TableCell>
              <TableCell>{devedor.razaoSocial}</TableCell>
              <TableCell>{devedor.nomeFantasia}</TableCell>
              <TableCell>{devedor.cnpjCpf ? formatCpfCnpj(devedor.cnpjCpf) : ''}</TableCell>
              <TableCell>{devedor.cidade || '-'}</TableCell>
              <TableCell>{devedor.idEstado}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

TableDevedorGrupo.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({
    idDevedor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    razaoSocial: PropTypes.string,
    nomeFantasia: PropTypes.string,
    cnpjCpf: PropTypes.string,
    cidade: PropTypes.string,
    idEstado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })),
};

TableDevedorGrupo.defaultProps = {
  content: [],
};
